import { render } from "./BoardTable.vue?vue&type=template&id=4e1d641d&scoped=true"
import script from "./BoardTable.vue?vue&type=script&lang=js"
export * from "./BoardTable.vue?vue&type=script&lang=js"

import "./BoardTable.vue?vue&type=style&index=0&id=4e1d641d&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e1d641d"]])

export default __exports__